export default "__VITE_ASSET__CRzcGzJ7__"